// burger menu
const burgerWrapper = document.querySelector('.header__burger-wrapper');
const burger = document.querySelector('.header__burger');
const mobileMenu = document.querySelector('.menu');
const menuMain = document.querySelector('.menu__lvl-1');
const menuButtons = document.querySelectorAll('.menu__item-open');
const menuBackButtons = document.querySelectorAll('.menu__back');

if (burger !== null) {
    burger.addEventListener('click', function() {
        burgerWrapper.classList.toggle('header__burger-wrapper--active')
        mobileMenu.classList.toggle('menu--active');
        burger.classList.toggle('header__burger--active');
        menuMain.classList.toggle('menu__list--open')
    })
}

// menu

function closeNextElements(element) {
    if (element === null) return;
    const nextElements = element.querySelectorAll('.menu__list--open');
    if (nextElements.length !== 0) {
        nextElements.forEach(nextElement => {
            nextElement.classList.remove('menu__list--open');
        })
    }
}

function openMenuElement(e) {
    const button = e.target;
    const relatedMenu = button.closest('.menu__list');
    if (relatedMenu !== null) {
        const relatedItem = button.closest('.menu__list-item');
        closeNextElements(relatedMenu);
        const relatedItemMenu = relatedItem.querySelector('.menu__list');
        if (relatedItemMenu !== null) {
            relatedItemMenu.classList.add('menu__list--open');
        }
    } else {
        console.log('menu not found');
    }
}

if (menuButtons.length !== 0) {
    menuButtons.forEach(button => {
        button.addEventListener('click', openMenuElement);
    })
}

if (menuBackButtons.length !== 0) {
    menuBackButtons.forEach(button => {
        const relatedMenu = button.closest('.menu__list');
        button.addEventListener('click', function() {
            if (relatedMenu !== null) {
                relatedMenu.classList.remove('menu__list--open');
            }
        })
    })
}
